import { useRef, useState } from 'react';
import { PASSWORD_MIN_LENGTH } from '@arc/shared/util-superstruct';
import { InputTextFieldWithControl } from './InputTextFieldWithControl';
import { VisibilityToggle } from './VisibilityToggle';
export function PasswordInput(props) {
  const [passwordShown, setPasswordShown] = useState(false);
  const inputRef = useRef(null);
  return <InputTextFieldWithControl {...props} type={passwordShown ? 'text' : 'password'} endAdornment={<VisibilityToggle visible={passwordShown} setVisible={setPasswordShown} inputRef={inputRef} />} context={{
    minLength: PASSWORD_MIN_LENGTH
  }} autoComplete="new-password" ref={inputRef} data-clarity-mask="true" data-sentry-mask="true" />;
}